export default "__VITE_ASSET__5e9b0e91__"